import { noop } from 'lodash';
import { memo } from 'react';

import { usePDFOutlineContext } from '~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext';
import { PDFPageControls } from '~/components/AssetModalV2/Visualizer/PDFVisualizer/PDFControls/components/PDFPageControls';

export const AssetModalContentHeaderPdfPageControls = memo(() => {
  const { currentPage, numPages, changePage } = usePDFOutlineContext();

  if (!(numPages > 0)) {
    return null;
  }

  return <PDFPageControls currentPage={currentPage} totalPages={numPages} goToPage={changePage} onFocusChange={noop} />;
});

AssetModalContentHeaderPdfPageControls.displayName = 'AssetModalContentHeaderPdfPageControls';
